import type { ReactElement } from 'react';
import { Group, SegmentedControl, Stack, Text, Title } from '@mantine/core';
import type { RuleBuilder } from '../shared/useRuleBuilder';
import { RuleNameInput } from '../shared/RuleNameInput';

export const RuleCreateReview = ({
  builder,
  publish,
  onPublishChange,
  onNameChange,
}: {
  builder: RuleBuilder;
  publish: boolean;
  onPublishChange: (publish: boolean) => void;
  onNameChange?: (name: string) => void;
}): ReactElement => {
  return (
    <Stack gap="lg">
      <Stack gap="xs">
        <Title order={2} size="h4">
          {publish
            ? builder.translate('pages:rules.builder.reviewTitle')
            : builder.translate('pages:rules.builder.reviewDraftTitle')}
        </Title>
        <Text size="sm" c="dimmed">
          {builder.translate('pages:rules.builder.reviewDescription')}
        </Text>
      </Stack>
      <RuleNameInput
        builder={builder}
        onChange={onNameChange}
        description={builder.translate('pages:rules.builder.nameDescription')}
      />
      <Group gap="md">
        <Text id="rule-create-status-label" size="sm" c="dimmed">
          {builder.translate('pages:rules.builder.initialStatus')}
        </Text>
        <SegmentedControl
          aria-labelledby="rule-create-status-label"
          value={publish ? 'published' : 'draft'}
          onChange={(value) => onPublishChange(value === 'published')}
          radius="xl"
          data={[
            {
              value: 'published',
              label: builder.translate('pages:rules.builder.turnedOn'),
            },
            {
              value: 'draft',
              label: builder.translate('pages:rules.builder.savedDraft'),
            },
          ]}
        />
      </Group>
    </Stack>
  );
};
